<template lang="pug">
.container
  .row
    .col-12.text-right
      router-link(to="/dashboard") Skip for now
  .row
    .col-12.text-center(v-if="id == 0")
      h1 Welcome to Return Postage!
      img.big-logo(src="@/assets/img/package-lg.png")
      //- img(src="@/assets/img/gandalf.gif")
      br
      br
      p To get started, let's set up a few things together.
      br
      button.get-started.btn.btn-primary(v-on:click="nextStep") Get Started
  .row
    .col-12.text-center(v-if="id == 1")
      h1 Step One: Add a return address
      img(src='@/assets/img/ufo-basic.png')
      br
      br
      ReturnAddress(
        :gandalf="true"
        :editAddress="false"
        @nextStep="nextStep"
      )      
      .row.text-center.justify-content-between
        .col-4
          button.btn.btn-primary(type="button" v-on:click="prevStep") Previous
        .col-4
          button.btn.btn-primary.gandalf-check(v-on:click="nextStep") Next
  .row  
    .col-12.text-center(v-if="id == 2")
      h1 Step Two: Connect a Platform
      img(src='@/assets/img/ufo-standard.png')      
      br
      br      
      ConnectPlatform(
        :gandalf="true"
        :oAuthReturn="$route.query"
      )
      .row.text-center.justify-content-between
        .col-4
          button.btn.btn-primary(v-on:click="prevStep") Previous
        .col-4  
          button.btn.btn-primary(v-on:click="nextStep") Next
  .row
    .col-12.text-center(v-if="id == 3")
      h1 Step Three: Connect a Shipping Carrier
      img(src='@/assets/img/ufo-premium.png')      
      br
      br
      ConnectCarrier(
        :gandalf="true"
      )      
      .row.text-center.justify-content-between
        .col-4
          button.btn.btn-primary(type="button" v-on:click="prevStep") Previous
        .col-4
          button.btn.btn-primary(v-on:click="nextStep") Next
    .col-12.text-center(v-if="id == 4")
      h1 Step Four: Congratulations
      //- img(src="@/assets/img/gandalf-farewell.gif")
      img.big-logo(src="@/assets/img/package-lg.png")
      br
      br
      p 
      .row.text-center.justify-content-between
        .col-4
          button.btn.btn-primary(v-on:click="prevStep()") Previous
        .col-4
          router-link(to="/dashboard")
            button.btn.btn-primary() Finish
  


</template>

<script>
import ConnectCarrier from '@/components/ConnectCarrier'
import ConnectPlatform from '@/components/ConnectPlatform'
import ReturnAddress from '@/components/ReturnAddress'
// import Router from 'vue-router'
// import router from ''
export default {
  name: 'Gandalf',
  props: {
    id:String
    
  },
  components:{
    ReturnAddress,
    ConnectCarrier,
    ConnectPlatform    
  },
  metaInfo: {
    title: 'Wizard',
  },
  data:function(){
    return{
      msg:null,
      step:null,
      step1Done:false,
      step2Done:false,
      step3Done:false,
      returnAddress:{},
      platform:false,
      woocommerce:{
        selected:false
      },
      shopify:{
        selected:false
      },
      // platform:{},
      // carrier:{},
      carrier:null,      
      fedex:{
        selected:false
      },
      ups:{
        selected:false,
        step:1,
      },
      usps:{
        selected:false
      },
      
    }
  },
  watch: {
   

      // initialize gandalf      
      //   get step from route id
      //   load in component
      //     component check if it's in gandalf
      //       if in gandalf, grab data from local storage. 
      //       If save info
      //     End of gandalf, validate info from local storage
        
     
  },

  methods:{
    step1Check(){
      // this.returnAddress = step1Data;
      this.step1Done = true;
    },
    async nextStep(){
      this.$router.push({path:`/dashboard/wizard/${Number(this.id)+1}`})
      this.step++
    },
    async prevStep(){
      this.$router.push({path:`/dashboard/wizard/${Number(this.id)-1}`})
      this.step--
    },
    async carrierSelect(carrier){
      this.fedex.selected = false;
      this.ups.selected = false;
      this.usps.selected = false;      
      this.carrier = carrier;
      this[carrier].selected = true;
    },
    async platformSelect(platform){
      this.woocommerce.selected = false;
      this.shopify.selected = false;      
      this.platform = platform;
      this[platform].selected = true;
    },
    async step1(){
      this.step1Done = true;
      this.step = 2;
      window.scrollTo(0,0);
    },
    backToStep0(){
      this.step = 0
    },
    async step2(){
      this.step2Done = true;
      this.step = 3;
      window.scrollTo(0,0);

      // this.axios.post('/rp/server/connectPlatform')
      // .then(response=>{
      //   if(response.data.error){
      //     this.errorHandler(response)
      //   }else if(response.data.message){
      //     this.step = 3;
      //   }
      // })

    },
    backToStep1(){
      this.step2Done = false;
      this.step = 1;
      window.scrollTo(0,0);
    },
    async step3(){
      this.step3Done = true;
      this.step = 4;
      window.scrollTo(0,0);
      // this.axios.post('/rp/server/addAddress')
      // .then(response=>{
      //   if(response.data.error){
      //     this.errorHandler(response)
      //   }else if(response.data.message){
      //     this.step = 4;
      //   }
      // })
    },
    backToStep2(){
      this.step3Done = false;
      this.step = 2;
      window.scrollTo(0,0);
    },

    async errorHandler(response){
      this.flash(response.data.error, 'error');

    }
  },
  async mounted(){
    // if (localStorage.getItem('returnAddress')) this.returnAddress = JSON.parse(localStorage.getItem('returnAddress'));
  },
  async created(){    
    this.step = this.id

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .big-logo{
    width:200px;
  }
  .skip-wizard{
    margin-top:100px;
  }
  // .gandalf-check{
  //   opacity:.5;
  // }
  // .gandalf-check.active{
  //   opacity:1;
  // }
  .card-body{
    img{
      height:100%;
    }
  }
  button{
    margin-top:50px;
  }
  .carrier-card{
    height:200px;
    transition:height .2s;
    .card-body.selected{
      background-color:rgba(0,0,0,.1);
      
    }  
  }
  .carrier-card.active{
    transition:height .2s;
    height:150px;
  }
  .carrier-card.selected{
    background-color:rgba(0,0,0,.1);
  }
  .fade-enter-active {
    transition: opacity .4s;
  }
  .fade-leave-active {
    display:none;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
